export default __webpack_public_path__ + "static/ave4-2378e4aa1b307d9a8bc1a2e08aca17ca.jpg";